<div
    class="row"
    [ngClass]="{ 'has-error': submitted && !image && required }"
>
    <label class="col-{{ labelColSize }}">
        {{ "signScan.photo" | translate }}
    </label>

    <div class="col-{{ colSize }}">
        <label
            class="p-inputtext m-input-file m-input-group-w-icon"
            for="fileInput"
        >
            <span class="label mr-16">
                @if (image) {
                    {{ image.name }}
                }
                @if (!image) {
                    {{ "general.selectFile" | translate }}
                }
            </span>

            <app-svg-icon
                class="ml-auto"
                icon="upload"
            >
            </app-svg-icon>

            <input
                id="fileInput"
                #file
                [accept]="acceptString()"
                (change)="setImage(file)"
                onclick="value = null"
                type="file"
            />
        </label>

        @if (imagePreview) {
            <div
                class="m-preview m-preview-sm mt-8"
                style="display: inline-flex"
            >
                <img
                    [attr.src]="imagePreview | safeHtml"
                    [ngStyle]="{ cursor: popup ? 'pointer' : 'unset' }"
                    (click)="popup && onImageClick()"
                />
                @if ((attachment || submitted) && imagePreview) {
                    <app-icon-button
                        (click)="setPhotoDeleted()"
                        icon="delete"
                    >
                    </app-icon-button>
                }
            </div>
        }

        @if (submitted && !image && required) {
            <div class="error">
                {{ "validation.required" | translate }}
            </div>
        }
    </div>
</div>
<app-image-dialog></app-image-dialog>
